<div class="layout h-screen">
  <app-side-bar class="h-screen layout__sidebar"></app-side-bar>

  <div class="layout__content flex flex-column h-screen">
    <app-top-bar class="w-full">
      @if (permissions.can('sales', 'create') && currentRoute() !== newSaleRoute) {
        <a class="layout__sale-shortcut" data-testid="global-new-sale" [routerLink]="newSaleRoute"><kbd>F2</kbd> Nova venda</a>
      }
    </app-top-bar>

    @if (isTrialExpired()) {
      <aside
        class="layout__read-only-banner"
        data-testid="trial-expired-banner"
        role="status">
        <div class="layout__read-only-banner-icon">
          <lucide-icon name="lock" size="15" aria-hidden="true" />
        </div>
        <p class="layout__read-only-banner-text">
          <strong class="layout__read-only-banner-title">Seu período de teste terminou.</strong>
          <span class="layout__read-only-banner-subtitle">Seus dados continuam disponíveis para consulta.</span>
        </p>
        <a routerLink="/assinatura" class="layout__read-only-banner-action">
          <span>Ver planos</span>
          <lucide-icon name="arrow-right" size="14" aria-hidden="true" />
        </a>
      </aside>
    }

    <main class="layout__main p-6 overflow-auto flex-grow-1">
      <router-outlet />
    </main>

  </div>

  <app-mobile-navigation></app-mobile-navigation>

  <app-command-palette></app-command-palette>

  <app-guided-tour-host />

  <app-onboarding-welcome />
</div>
